import React from 'react'
import isBefore from 'date-fns/isBefore'
import { Icon, Intent } from '@blueprintjs/core'

export const EstimatedTimeWarning = ({ pickupTime }: { pickupTime: string }) =>
  isBefore(new Date(pickupTime), new Date()) ? (
    <Icon icon="warning-sign" intent={Intent.DANGER} />
  ) : null
